(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
	class ProductModal extends ModalDialog {
		constructor() {
			super();
		}
		hide() {
			super.hide();
			window.pauseAllMedia();
		}
		show(opener) {
			super.show(opener);
			//this.showActiveMedia();
			this.constProductPageSwiperCall()
		}
		showActiveMedia() {
			this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
					element.classList.remove('active');
				}
			)
			const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
			activeMedia.classList.add('active');
			activeMedia.scrollIntoView();
			if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
				activeMedia.loadContent();
		}			
		constProductPageSwiperCall(showActiveMedia) {
			const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
			let activeMediaIndex = 0
			
			this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
					if(element == activeMedia){
						activeMediaIndex = index
					}
				}
			)
			const prodPageSwiper = new Swiper("#featured-product-swiper", {
				zoom: true,
				centeredSlides: false,
				slidesPerView: 1,
				autoheight: true,
				watchSlidesVisibility: false,
				watchSlidesProgress: true,
				observer: true,
				observeParents: true,
				init: false,
				navigation: {
					nextEl: ".swiper-button-next-prod-page",
					prevEl: ".swiper-button-prev-prod-page",
				}
			});
			prodPageSwiper.on('init', function() {
				prodPageSwiper.slideTo(activeMediaIndex, 0, false);
			});
			prodPageSwiper.init()
			document.querySelector('.product-media-modal__toggle').addEventListener("click", function(){ prodPageSwiper.destroy() });
		}
	}

	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();
			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then(response => response.text())
					.then(text => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('product-recommendations--single');
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch(e => {
						console.error(e);
					});
			}
			new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
		}
	}

	customElements.define('product-modal', ProductModal);
	customElements.define('product-recommendations--single', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector(
					'input[name="locale_code"], input[name="country_code"]'
				),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener(
				'click',
				this.openSelector.bind(this)
			);
			this.elements.button.addEventListener(
				'focusout',
				this.closeSelector.bind(this)
			);
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach((item) =>
				item.addEventListener('click', this.onItemClick.bind(this))
			);
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			this.elements.input.value = event.currentTarget.dataset.value;
			this.querySelector('form')?.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute(
				'aria-expanded',
				(
					this.elements.button.getAttribute('aria-expanded') === 'false'
				).toString()
			);
		}

		closeSelector(event) {
			const shouldClose =
				event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel();
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.headerId = document.getElementById("section-header").getAttribute('data-header-id');
		this.header = document.getElementById(`shopify-section-${this.headerId}`);
		this.headerBounds = {};
		this.currentScrollTop = 0;

		this.onScrollHandler = this.onScroll.bind(this);

		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		observer.observe(this.header);
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		requestAnimationFrame(this.hide.bind(this));
		if (this.predictiveSearch && this.predictiveSearch.onFocusOut) {
			this.predictiveSearch.onFocusOut();
			this.predictiveSearch.onBlur();
		} 
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		requestAnimationFrame(this.reveal.bind(this));
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
	}

	this.currentScrollTop = scrollTop;
	}

	hide() {
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		this.disclosures.forEach(disclosure => disclosure.close());
	}

	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}
	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }
    
    connectedCallback() {
      // Remove any existing modal with the same ID from body before appending new one
      // This fixes the issue when switching products via Section Rendering API
      const existingModal = document.body.querySelector(`#${this.id}`);
      if (existingModal && existingModal !== this) {
        existingModal.remove();
      }
      
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
    }
    
    hide() {
      super.hide();
      window.pauseAllMedia();
    }
    show(opener) {
      super.show(opener);
      //this.showActiveMedia();
      this.constProductPageSwiperCall();
    }
    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();
      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }

    constProductPageSwiperCall(showActiveMedia) {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      let activeMediaIndex = 0;

      this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
        if (element == activeMedia) {
          activeMediaIndex = index;
        }
      });
      
      // Use this modal's swiper element instead of global selector
      const swiperContainer = this.querySelector('.swiper');
      const nextEl = this.querySelector('.swiper-button-next-prod-page');
      const prevEl = this.querySelector('.swiper-button-prev-prod-page');
      const paginationEl = this.querySelector('.swiper-pagination-product-page');
      const closeBtn = this.querySelector('.product-media-modal__toggle');
      
      var prodPageSwiper = new Swiper(swiperContainer, {
        zoom: true,
        centeredSlides: false,
        slidesPerView: 1,
        autoheight: true,
        watchSlidesVisibility: false,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
        init: false,
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        on: {
          slideChangeTransitionEnd: function () {
            this.zoom.in(3);
          },
        },
      });
      prodPageSwiper.on('init', function () {
        prodPageSwiper.slideTo(activeMediaIndex, 0, false);
        prodPageSwiper.zoom.in(3);
      });
      prodPageSwiper.init();
      
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
        prodPageSwiper.destroy();
      });
      }
    }
  }

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations--single');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-modal', ProductModal);
  customElements.define('product-recommendations--single', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
                        //console.log(1111);
                        if (window.innerWidth <= 768) {
                            var init = false;
                            var swiper;
                            // Function that actually builds the swiper 
                            const buildSwiperSlider = sliderElm => {
                              const sliderIdentifier = sliderElm.dataset.id;
                              
                              if(sliderElm.closest('[data-images]').dataset.images != ""){
                                var imageDiv = sliderElm.closest('[data-images]').dataset.images;
                                sliderElm.querySelector('.swiper-wrapper').innerHTML = imageDiv;
                                return new Swiper(`.p${sliderIdentifier}`, {
                                  centeredSlides: false,
                                  slidesPerView: "auto",
                                  spaceBetween: 30,
                                  navigation: {
                                      nextEl: `.swiper-button-next-${sliderIdentifier}`,
                                      prevEl: `.swiper-button-prev-${sliderIdentifier}`
                                  },
                                  pagination: {
                                      el: `.swiper-pagination-${sliderIdentifier}`,
                                    clickable: true,
                                  },
                              });
                              }
                            }
                      
                            // Get all of the swipers on the page
                            const allSliders = document.querySelectorAll('.swiper.media-swiper');
                            
                            // Loop over all of the fetched sliders and apply Swiper on each one.
                            allSliders.forEach(slider => buildSwiperSlider(slider));
                        }
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
	class RecentlyViewedProducts extends HTMLElement {
		constructor() {
			super();
			this.storageKey = 'recently-viewed-products';
			this.maxProducts = 20;
			this.currentProductHandle = this.dataset.productHandle;
			this.productsToShow = parseInt(this.dataset.productsToShow) || 8;
			this.sectionId = this.dataset.sectionId;

			// Track the current product if on a product page
			if (this.currentProductHandle) {
				this.trackProduct(this.currentProductHandle);
			}

			// Display recently viewed products
			this.displayProducts();
		}

		trackProduct(handle) {
			if (!handle) return;

			let products = this.getStoredProducts();
			
			// Remove the product if it already exists (to move it to the front)
			products = products.filter(p => p !== handle);
			
			// Add to the beginning of the array
			products.unshift(handle);
			
			// Limit to max products
			products = products.slice(0, this.maxProducts);
			
			// Save to localStorage
			localStorage.setItem(this.storageKey, JSON.stringify(products));
		}

		getStoredProducts() {
			try {
				const stored = localStorage.getItem(this.storageKey);
				return stored ? JSON.parse(stored) : [];
			} catch (e) {
				return [];
			}
		}

		async displayProducts() {
			let products = this.getStoredProducts();
			
			// Exclude current product from display
			if (this.currentProductHandle) {
				products = products.filter(p => p !== this.currentProductHandle);
			}
			
			// Limit to products to show
			products = products.slice(0, this.productsToShow);
			
			const header = this.querySelector('.recently-viewed__header');
			const list = this.querySelector('.recently-viewed__list');
			const emptyMessage = this.querySelector('.recently-viewed__empty');
			
			if (!list) return;

			if (products.length === 0) {
				// Show empty message
				if (emptyMessage) {
					emptyMessage.style.display = 'block';
				}
				// Show the header even when empty
				if (header) {
					header.style.display = '';
				}
				return;
			}

			// Hide empty message if products exist
			if (emptyMessage) {
				emptyMessage.style.display = 'none';
			}

			// Fetch and render each product
			const productPromises = products.map(handle => this.fetchProduct(handle));
			const productCards = await Promise.all(productPromises);
			
			// Filter out any null results (products that couldn't be fetched)
			const validCards = productCards.filter(card => card !== null);
			
			if (validCards.length === 0) {
				// Show empty message if no valid products
				if (emptyMessage) {
					emptyMessage.style.display = 'block';
				}
				// Show the header even when empty
				if (header) {
					header.style.display = '';
				}
				return;
			}

			// Show the header
			if (header) {
				header.style.display = '';
			}

			// Render products
			const perRow = parseInt(getComputedStyle(this).getPropertyValue('--per-row')) || 4;
			
			validCards.forEach((card, index) => {
				const condition = (index + 1) % perRow;
				const blockClass = condition === 0 ? 'hide_border' : '';
				
				const li = document.createElement('li');
				li.className = `collection-product-card recently-viewed__product quickview${window.settings?.quickview_hover ? '--hover' : ''} show ${blockClass}`;
				li.innerHTML = card;
				list.appendChild(li);
			});

			// Initialize mobile swiper if needed
			this.initMobileSwiper();
		}

		async fetchProduct(handle) {
			try {
				const response = await fetch(`/products/${handle}?section_id=recently-viewed-product-card`);
				if (!response.ok) return null;
				
				const html = await response.text();
				const parser = new DOMParser();
				const doc = parser.parseFromString(html, 'text/html');
				const productCard = doc.querySelector('.recently-viewed-card-wrapper');
				
				return productCard ? productCard.innerHTML : null;
			} catch (e) {
				console.error('Error fetching product:', handle, e);
				return null;
			}
		}

		initMobileSwiper() {
			if (window.innerWidth <= 768 && typeof Swiper !== 'undefined') {
				const allSliders = this.querySelectorAll('.swiper.media-swiper');
				
				allSliders.forEach(sliderElm => {
					const sliderIdentifier = sliderElm.dataset.id;
					const imageDiv = sliderElm.closest('[data-images]')?.dataset.images;
					
					if (imageDiv) {
						sliderElm.querySelector('.swiper-wrapper').innerHTML = imageDiv;
						new Swiper(`.p${sliderIdentifier}`, {
							centeredSlides: false,
							slidesPerView: "auto",
							spaceBetween: 30,
							navigation: {
								nextEl: `.swiper-button-next-${sliderIdentifier}`,
								prevEl: `.swiper-button-prev-${sliderIdentifier}`
							},
							pagination: {
								el: `.swiper-pagination-${sliderIdentifier}`,
								clickable: true,
							},
						});
					}
				});
			}
		}
	}

	customElements.define('recently-viewed-products', RecentlyViewedProducts);

  } catch(e) { console.error(e); }
})();
})();
